import axios from '../../api';

const BASE = process.env.REACT_APP_URL;

export const getKeluhanList = (params = {}) =>
  axios.get(`${BASE}/keluhan`, {
    params: {
      page: params.page || 1,
      limit: params.limit || 10,
      BantuanId: params.BantuanId,
    },
  });

export const getKeluhanById = (id) =>
  axios.get(`${BASE}/keluhan/${id}`);

export const createKeluhan = (formData) =>
  axios.post(`${BASE}/keluhan`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const createKeluhanFollowUp = (id, formData) =>
  axios.post(`${BASE}/keluhan/${id}/tindak-lanjut`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const updateKeluhan = (id, formData) =>
  axios.put(`${BASE}/keluhan/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteKeluhan = (id) =>
  axios.delete(`${BASE}/keluhan/${id}`);

const keluhanApi = {
  getKeluhanList,
  getKeluhanById,
  createKeluhan,
  updateKeluhan,
  deleteKeluhan,
};

export default keluhanApi;
